import { NgModule } from '@angular/core';
import { CommonModule, NgForOf } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FrontendDropdownComponent, FrontDropdownListComponent } from './components';
import { FrontendTripleDotsModule } from '@tablesready/frontend-triple-dots';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendTooltipModule } from '@tablesready/frontend-tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
  declarations: [FrontDropdownListComponent, FrontendDropdownComponent],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    IonicModule,
    OverlayModule,
    ScrollingModule,
    NgForOf,
    FrontendTripleDotsModule,
    FrontendIconsModule,
    FrontendTooltipModule,
  ],
  exports: [FrontendDropdownComponent, FrontDropdownListComponent],
})
export class FrontendDropdownModule {}
